import { render } from "./SectionQuestions.vue?vue&type=template&id=e34d0d72"
import script from "./SectionQuestions.vue?vue&type=script&lang=js"
export * from "./SectionQuestions.vue?vue&type=script&lang=js"

import "./SectionQuestions.vue?vue&type=style&index=0&id=e34d0d72&lang=scss"
script.render = render

export default script